const URL = {
  NEWS_LIST: '/api/cms/content/pageList',
  NEWS_LIST2: '/api/cms/content/carouselList',
  RECRUITMENT_LIST: '/demo/news/getRecruitList',
  RECRUITMENT_DETAIL: '/api/cms/content/'
}

export default URL
